import React, { useState, useEffect } from 'react'
import { api } from '../api'

const STATUT_LABELS = {
  en_cours_commercial: { label: 'En cours — Commercial', color: '#534AB7' },
  en_attente_facilitateur: { label: 'À traiter', color: '#EF9F27' },
  en_cours_facilitateur: { label: 'En cours — Facilitateur', color: '#0F6E56' },
  termine: { label: 'Terminé', color: '#639922' },
}

export default function Dashboard({ onOpenDossier }) {
  const [dossiers, setDossiers] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('tous')
  const [search, setSearch] = useState('')

  useEffect(() => {
    load()
  }, [])

  const load = async () => {
    setLoading(true)
    try {
      const data = await api.getDossiers()
      setDossiers(data)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const handleOpen = async (item) => {
    try {
      const full = await api.getDossier(item.id)
      onOpenDossier(full)
    } catch (e) {
      alert('Erreur chargement dossier')
    }
  }

  const filtered = dossiers.filter(d => {
    const matchFilter = filter === 'tous' || d.statut === filter
    const matchSearch = d.raison_sociale?.toLowerCase().includes(search.toLowerCase()) ||
      d.siren?.includes(search)
    return matchFilter && matchSearch
  })

  const stats = {
    tous: dossiers.length,
    en_attente_facilitateur: dossiers.filter(d => d.statut === 'en_attente_facilitateur').length,
    en_cours_facilitateur: dossiers.filter(d => d.statut === 'en_cours_facilitateur').length,
    termine: dossiers.filter(d => d.statut === 'termine').length,
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="page-title">Tableau de bord</h1>
        <input
          className="search-input"
          placeholder="Rechercher une entreprise, un SIREN..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-value">{stats.tous}</div>
          <div className="stat-label">Dossiers total</div>
        </div>
        <div className="stat-card stat-card--warning">
          <div className="stat-value">{stats.en_attente_facilitateur}</div>
          <div className="stat-label">À traiter</div>
        </div>
        <div className="stat-card stat-card--primary">
          <div className="stat-value">{stats.en_cours_facilitateur}</div>
          <div className="stat-label">En cours</div>
        </div>
        <div className="stat-card stat-card--success">
          <div className="stat-value">{stats.termine}</div>
          <div className="stat-label">Terminés</div>
        </div>
      </div>

      <div className="filter-tabs">
        {[
          { key: 'tous', label: 'Tous' },
          { key: 'en_attente_facilitateur', label: 'À traiter' },
          { key: 'en_cours_facilitateur', label: 'En cours' },
          { key: 'termine', label: 'Terminés' },
        ].map(f => (
          <button
            key={f.key}
            className={`filter-tab ${filter === f.key ? 'active' : ''}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="loading">Chargement...</div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <p>Aucun dossier trouvé</p>
        </div>
      ) : (
        <div className="dossiers-list">
          {filtered.map(d => {
            const statut = STATUT_LABELS[d.statut] || { label: d.statut, color: '#888' }
            return (
              <div key={d.id} className="dossier-card" onClick={() => handleOpen(d)}>
                <div className="dossier-card-left">
                  <div className="dossier-name">{d.raison_sociale || '—'}</div>
                  <div className="dossier-meta">
                    SIREN : {d.siren || '—'}
                    {d.facilitateur && ` · ${d.facilitateur}`}
                  </div>
                  <div className="dossier-date">
                    Mis à jour : {d.updated_at ? new Date(d.updated_at).toLocaleDateString('fr-FR') : '—'}
                  </div>
                </div>
                <div className="dossier-card-right">
                  <span className="statut-badge" style={{ background: statut.color }}>
                    {statut.label}
                  </span>
                  <span className="dossier-arrow">›</span>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
